import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { WifiOffIcon, WifiIcon } from 'lucide-react';
import { useOnlineStatus } from '../../app/hooks/useOnlineStatus';
/**
 * F5.6 Offline Indicator
 *
 * - Toont een amber banner zolang de gebruiker offline is.
 * - Toont kort (3s) een groene "weer online" bevestiging na herstel.
 * - Niet-blokkerend: alle practice-functies blijven client-side werken.
 * - Respecteert safe-area-inset-top voor iPhones met notch.
 */
export function ConnectionStatus() {
  const {
    isOnline,
    wasOffline
  } = useOnlineStatus();
  const showOffline = !isOnline;
  const showReconnected = isOnline && wasOffline;
  return <AnimatePresence data-id="element-2364" data-mp="2nd0uscbp7glc">
      {showOffline && <motion.div key="offline" role="status" aria-live="polite" initial={{
      y: -40,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -40,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="fixed top-0 inset-x-0 z-[60] pt-safe" data-id="element-2365" data-mp="2s99aprxpzdtk">
          <div className="mx-auto max-w-2xl m-2 px-4 py-2.5 rounded-xl bg-amber-100 border border-amber-300 text-amber-900 shadow-md flex items-center gap-3" data-id="element-2366" data-mp="2d1p1d785pz5w">
            <WifiOffIcon className="w-4 h-4 flex-shrink-0" aria-hidden="true" data-id="element-2367" data-mp="284f0mvfbi12r" />
            <p className="text-xs sm:text-sm font-semibold leading-tight" data-id="element-2368" data-mp="1kcrt7wxntiqv">
              Je bent offline — je voortgang wordt opgeslagen zodra je weer
              verbinding hebt.
            </p>
          </div>
        </motion.div>}

      {showReconnected && <motion.div key="reconnected" role="status" aria-live="polite" initial={{
      y: -40,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -40,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="fixed top-0 inset-x-0 z-[60] pt-safe" data-id="element-2369" data-mp="1pajj6lequusf">
          <div className="mx-auto max-w-2xl m-2 px-4 py-2.5 rounded-xl bg-emerald-100 border border-emerald-300 text-emerald-900 shadow-md flex items-center gap-3" data-id="element-2370" data-mp="3hruew2ad1fa1">
            <WifiIcon className="w-4 h-4 flex-shrink-0" aria-hidden="true" data-id="element-2371" data-mp="2p3gkrxme733r" />
            <p className="text-xs sm:text-sm font-semibold leading-tight" data-id="element-2372" data-mp="2p1djuijpbpk9">
              Je bent weer online!
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}